document.addEventListener('DOMContentLoaded', () => {
  // .content-nav-display가 있는지 확인
  const navDisplay = document.querySelector('.content-nav-display');
  // 현재 URL의 hash 읽기
  const currentHash = window.location.hash; // 예: "#about"
  if (navDisplay && currentHash){
    let nav = $(navDisplay).attr('data-navtab');
    $(navDisplay).find(`.content-nav[data-navtab=${nav}] > li > a`).removeClass('active');
    $(navDisplay).find(`.content-wrap[data-navtab=${nav}] > .feature`).removeClass('active');
    $(navDisplay).find(`.content-nav[data-navtab=${nav}] > li > a[href="${currentHash}"]`).addClass('active');
    $(navDisplay).find(`.content-wrap[data-navtab=${nav}] > .feature${currentHash}`).addClass('active');
  }
});

$(document).on('click', '.content-nav-display .content-nav a', function(e) {
  e.preventDefault();
  let contentId = $(this).attr('href');
  let $parent = $(this).closest('.content-nav-display');
  let nav = $parent.attr('data-navtab');

  let $contentNav = nav ? $(`.content-nav[data-navtab=${nav}]`) : $(this).closest('.content-nav');
  let $contentWrap = nav ? $(`.content-wrap[data-navtab=${nav}]`) : $parent.find('.content-wrap');

  $contentNav.find('a').removeClass('active');
  $(this).addClass('active');
  $contentWrap.children('.feature').removeClass('active');
  $contentWrap.children(`.feature${contentId}`).addClass('active');

  if(nav) {
    window.history.pushState({}, '', contentId);
  }
});

// 드롭다운 토글
$(document).on('click', '.dropdown-toggle', function (e) {
  e.preventDefault();
  let $dropdown = $(this).closest('.dropdown');
  // 다른 드롭다운 닫기
  $('.dropdown-menu').not($dropdown.find('.dropdown-menu')).removeClass('show');
  // 현재 드롭다운 열기/닫기
  $(this).toggleClass('open');
  $dropdown.find('.dropdown-menu').toggleClass('show');
});
$(document).on('click', '.dropdown .dropdown-item', function (e) {
  let $dropdown = $(this).closest('.dropdown');
  let selectText = $(this).text();
  $dropdown.find('.dropdown-toggle').html(selectText + '<i class="arrow"></i>');
  $dropdown.find('.dropdown-menu').removeClass('show');
});
// 바깥 클릭 시 닫기
$(document).on('click', function (e) {
  if (!$(e.target).closest('.dropdown').length) {
    $('.dropdown-menu').removeClass('show');
    $('.dropdown-toggle').removeClass('open');
  }
});

// 아코디언 버튼 클릭 이벤트
$(document).on('click', '.accordion [data-toggle="collapse"]', function () {
  const $btn = $(this);
  const target = $btn.data('target'); // "#collapseOne" 같은 값
  const $accordion = $btn.closest('.accordion'); // 부모 아코디언 컨테이너
  const $targetPanel = $accordion.find(target);
  let current = false;
  if ($targetPanel.hasClass('show')) current = true;

  let timer = $accordion.hasClass('no-trans-time') ? 0 : 300;
  
  // 같은 아코디언 내 다른 패널 닫기
  $accordion.find('.collapse.show').slideUp(timer);
  $accordion.find('[data-toggle="collapse"]').attr('aria-expanded', false);
  $accordion.find('[data-toggle="collapse"]').removeClass('active');
  setTimeout(() => {
    $accordion.find('.collapse.show').removeClass('show');
    $accordion.find('.collapse.show').addClass('collapsed');
  }, timer);

  // 이미 열려 있는 경우 노노
  if (!current) {
    $targetPanel.slideDown(timer);
    $(this).addClass('active');
    $(this).attr('aria-expanded', true);
    setTimeout(() => {
      $targetPanel.addClass('show');
      $(this).removeClass('collapsed');
    }, timer);
  }
});

// 페이지 to top
$(document).on('click', '.btn-to-top', function() {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
});

// 앵커 이동 애니메이션 + header 높이 반영
document.querySelectorAll('a.anchor-move[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
    const targetId = this.getAttribute('href');
    if (targetId.length > 1) {
      e.preventDefault(); // 기본 앵커 이동 막기
      const el = document.querySelector(targetId);
      if (el) {
        const y = el.getBoundingClientRect().top + window.pageYOffset - 50;
        window.scrollTo({
          top: y,
          behavior: 'smooth'
        });
      }
    }
  });
});


